import Container from "../../components/Container"
import Slider from "../../components/Slider"
import Title from "../../components/Title"
import Card from "./components/Card"

import "./Tips.scss"

const content = [
  {
    category: "Blog Itaú",
    title:
      "Suas contas estão sob controle? Entenda os sinais de alerta do endividamento",
    background: "images/landing/tips-1.png",
    link: "https://blog.itau.com.br/artigos/suas-contas-estao-sob-controle-entenda-os-sinais-de-alerta-do-endividamento",
  },
  {
    category: "Educação Financeira",
    title: "Aprenda a conquistar seus objetivos financeiros!",
    background: "images/landing/tips-2.png",
    link: "https://blog.itau.com.br/artigos/como-alcancar-seus-objetivos-parte-i",
  },
  {
    category: "Blog do Itaú",
    title: "Evitando o endividamento",
    background: "images/landing/tips-3.png",
    link: "https://blog.itau.com.br/artigos/evitando-o-endividamento",
  },
]

const sliderSettings = {
  slidesToShow: 1.6,
  responsive: [
    {
      breakpoint: 768,
    },
    {
      breakpoint: 10000,
      settings: "unslick",
    },
  ],
}

const Tips = () => {
  return (
    <section className="landing-tips">
      <Container>
        <Title className="landing-tips__title">
          Dicas para melhorar o controle do seu dinheiro
        </Title>
      </Container>
      <Slider settings={sliderSettings} content={content}>
        {content.map((item) => {
          return <Card key={item.title} content={item} />
        })}
      </Slider>
    </section>
  )
}

export default Tips
